import {Injectable} from '@angular/core';
import {GeneralService} from './general.service';
import {HttpClient} from '@angular/common/http';
import {UserRight} from '../interfaces/userRight';
import {UiSettingsService} from '../../shared/ui-settings.service';
import { SuperuserServiceModule } from '../superuser-service.module';

@Injectable({
  providedIn: SuperuserServiceModule
})
export class UserRightService extends GeneralService<UserRight> {

  constructor(http: HttpClient, uiSettingService: UiSettingsService) {
    super(http, uiSettingService, 'userrights', 'userright');
  }
}
